module.exports = __webpack_public_path__ + "img/icon-user.897a4d99.svg";